import type {LinkProps as ChakraLinkProps} from '@chakra-ui/react';
import {Icon, Link as BaseLink} from '@chakra-ui/react';
import {ChakraSpan} from '@linx-security/ui/utils/chakra-elements';
import type {LinkProps as NextLinkProps} from 'next/dist/client/link';
import NextLink from 'next/dist/client/link';

import {FiExternalLink} from '../../icons';

export type LinkProps = Omit<NextLinkProps, 'as' | 'href'> & ChakraLinkProps;

export const Link = (props: LinkProps) => {
  const isExternal = props.isExternal;
  return (
    <BaseLink
      as={NextLink}
      color={`text.link`}
      maxW={`full`}
      overflow={`hidden`}
      gap={`space-100`}
      fontSize={`inherit`}
      display={isExternal ? `flex` : undefined}
      alignItems={`center`}
      href={props.href}
      {...props}
    >
      <ChakraSpan whiteSpace={`nowrap`} overflow={`hidden`} textOverflow={`ellipsis`}>
        {props.children}
      </ChakraSpan>

      {isExternal && <Icon as={FiExternalLink} />}
    </BaseLink>
  );
};
